(function ($){
    var $body = $('body');

    $(document).ready(function () {
        $body.find('.modal.show').each(function () {
            $(this).modal('show');
        });
    });
})(require('jquery'));
